module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-form wwf-form-product",
    class: [{
      'formValidation-shake': _vm.isShake
    }, _vm.className]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.donation.isLoading),
      expression: "donation.isLoading"
    }],
    staticClass: "wwf-loading-container"
  }, [_vm._m(0, false, false)]), _vm._v(" "), _c('form-wizard', {
    ref: "wizard",
    attrs: {
      "shape": "tab",
      "start-index": _vm.stepIndex,
      "on-change": _vm.setFormStepState(_vm.stepIndex)
    },
    on: {
      "on-loading": _vm.setLoading,
      "update:startIndex": function($event) {
        _vm.stepIndex = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function(props) {
        return [_c('div', {
          staticClass: "form-buttons prev"
        }, [_c('a', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.activeTabIndex == 1),
            expression: "props.activeTabIndex == 1"
          }],
          style: (props.fillButtonStyle),
          attrs: {
            "href": "#form-top",
            "id": "Previous",
            "data-animation-duration": "300",
            "data-animation-easing": "swing",
            "data-smooth-scroll": "",
            "data-threshold": "75"
          },
          on: {
            "click": function($event) {
              props.prevTab()
            }
          }
        }, [_vm._v("Previous")])]), _vm._v(" "), _c('div', {
          staticClass: "form-buttons next"
        }, [_c('a', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.activeTabIndex != 2),
            expression: "props.activeTabIndex != 2"
          }],
          class: (props.activeTabIndex != 0 && _vm.donation.payementType == 'wwf_paypal') ? 'paypal-button' : '',
          style: (props.fillButtonStyle),
          attrs: {
            "href": "#form-top",
            "id": "Next",
            "data-animation-duration": "300",
            "data-animation-easing": "swing",
            "data-smooth-scroll": "",
            "data-threshold": "75"
          },
          on: {
            "click": function($event) {
              props.nextTab()
            }
          }
        }, [_vm._v(_vm._s((props.activeTabIndex == 0) ? 'Next' : ((_vm.donation.payementType == 'wwf_paypal') ? 'Pay with PayPal' : 'Go to payment')))])])]
      }
    }])
  }, [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Choose",
      "before-change": function () { return _vm.validateStep('step1'); }
    }
  }, [_c('Step1', {
    ref: "step1",
    attrs: {
      "useNewCheckout": _vm.useNewCheckout
    }
  })], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Details",
      "before-change": function () { return _vm.validateStep('step2'); }
    }
  }, [_c('Step2', {
    ref: "step2",
    attrs: {
      "disabledGoogleAutocomplete": _vm.disabledGoogleAutocomplete,
      "thankYouUrl": _vm.thankYouUrl,
      "useNewCheckout": _vm.useNewCheckout
    }
  })], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Payment"
    }
  }, [_c('Step3', {
    attrs: {
      "thankYouUrl": _vm.thankYouUrl,
      "useNewCheckout": _vm.useNewCheckout
    }
  })], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-loading"
  }, [_c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2495e1f4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=8hbdlddx288!./~/string-replace-webpack-plugin/loader.js?id=ayyc1bnkec!./src/components/product/FormProduct.vue
// module id = 400
// module chunks = 1